import React from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import CampoNit from "../custom/CampoNit";
import SelectorCiudad from "../custom/SelectorCiudad";
import Unauthorized from "../general/Unauthorized";

function NuevoProveedor() {

    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    
    // 🎯 ESTADO PARA ACORDEÓN REACT
    const [acordeonLocalizacion, setAcordeonLocalizacion] = useState(true);

    const [nombre, setNombre] = useState('');
    const [tipoDocumento, setTipoDocumento] = useState('nit');
    const [numeroDocumento, setNumeroDocumento] = useState('');
    const [dv, setDv] = useState('');
    const [direccion, setDireccion] = useState('');
    const [celular, setCelular] = useState('');
    const [telefono, setTelefono] = useState('');
    const [contacto, setContacto] = useState('');
    const [email, setEmail] = useState('');
    const [ciudad, setCiudad] = useState('');
    const [representanteLegal, setRepresentanteLegal] = useState('');
    const [banco, setBanco] = useState('');
    const [tipoCuenta, setTipoCuenta] = useState('ahorros');
    const [numeroCuenta, setNumeroCuenta] = useState('');
    const [codigoResponsabilidad, setCodigoResponsabilidad] = useState('No responsable');
    const [codigoRegimen, setCodigoRegimen] = useState('No responsable de IVA');
    const [codigoImpuesto, setCodigoImpuesto] = useState('No causa');


    let history = useHistory();

    let userdata = [];


    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔒 VALIDACIÓN DE PERMISOS - Verificar acceso a administrar personal y proveedores
        const tienePermiso = userdata.up && userdata.up.includes('administrarPersonalProveedores');
        
        if (!tienePermiso) {
            setHasPermission(false);
            return; // Detener ejecución si no tiene permisos
        }

        setHasPermission(true);

        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente
        
        axios.get('/get-client?uid='+userdata.user_id)
            .then(response => {
                if (response.status===200) {
                    setClient(response.data);
                    console.log('Client: '+client.client_id);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                
                console.log('err: '+error);
            });
    },[]);


    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const conf = {
            /*headers: { Authorization: 'Bearer ' + userdata.access_token },*/
            uid: userdata.user_id,
            nombre_proveedor: nombre,
            tipo_documento: tipoDocumento,
            numero_documento: numeroDocumento,
            dv: dv,
            direccion: direccion,
            telefono: telefono,
            celular: celular,
            contacto: contacto,
            email: email,
            ciudad: ciudad,
            representante_legal: representanteLegal,
            banco: banco,
            tipo_cuenta: tipoCuenta,
            numero_cuenta: numeroCuenta,
            codigo_responsabilidad: codigoResponsabilidad,
            codigo_regimen: codigoRegimen,
            codigo_impuesto: codigoImpuesto
        };
        
        console.log('📤 Datos a enviar:', conf); // 🔍 Debug
        
        axios.post('/proveedor', conf)
            .then(
                response => {
                    setLoading(false);
                    localStorage.setItem('toastmsg', 'El Proveedor "'+nombre+'" Ha Sido Creado');
                    history.push('/proveedores');
                }
            )
            .catch(
                err => {
                    console.log(err.response.data);
                    setLoading(false);
                }
            )
    }


    function handleNit(valor,digitoVerificacion) {
        setNumeroDocumento(valor);
        setDv(digitoVerificacion);
        console.log('NIT:', valor, 'DV:', digitoVerificacion); // 🔍 Debug
    }


    const handleCiudadProveedor = (valorCiudad) => {
        setCiudad(valorCiudad);
    }


    // 🔒 PROTECCIÓN DE RUTA - Si no tiene permisos, mostrar página de acceso denegado
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/personal-proveedores">Administrador de Personal y Proveedores</Link></li>
                                        <li className="breadcrumb-item" key="bc4"><Link to="/proveedores">Proveedores</Link></li>
                                        <li className="breadcrumb-item" key="bc5">Nuevo Proveedor</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Nuevo Proveedor</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            <div className="row">
                                <div className="col-md-12">
                                    
                                    <form id="role-form" onSubmit={handleSubmit}>
                                        <div className="card">
                                            <div className="card-header" onClick={() => setAcordeonLocalizacion(!acordeonLocalizacion)} style={{cursor: 'pointer'}}>
                                                <h4 className="card-title w-100">
                                                    <span className="d-block w-100">
                                                        Información de Localización {acordeonLocalizacion ? '▼' : '▶'}
                                                    </span>
                                                </h4>
                                            </div>
                                            <div id="infobasica" className={acordeonLocalizacion ? '' : 'collapse'}>
                                                <div className="card-body">
                                                
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="nombre">Nombre o Razón Social</label>
                                                                <input type="text" name="nombre" className="form-control" id="nombre" onChange={(e) => setNombre(e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="lastname">Tipo de Documento</label>
                                                                <select name="tipoDocumento" id="tipoDocumento" className="form-control" onChange={(e) => setTipoDocumento(e.target.value)}>
                                                                   <option value=""></option>
                                                                        <option value="cc">CC - CEDULA DE CIUDADANIA</option>
                                                                        <option value="ce">CE - CEDULA DE EXTRANJERIA</option>
                                                                        <option value="CD">CD - CARNET DIPLOMATICO</option>
                                                                        <option value="CN">CN - CERTIFICADO DE NACIDO VIVO</option>
                                                                        <option value="DE">DE - DOCUMENTOS EXTRANJERO</option>
                                                                        <option value="MS">MS - MENOR SIN IDENTIFICAR</option>
                                                                        <option value="NIP">NIP - NUMERO DE IDENTIFICACION PERSONAL</option>
                                                                        <option value="NIT">NIT - NUMERO DE IDENTIFICACION TRIBUTARIA</option>
                                                                        <option value="PA">PA - PASAPORTE</option>
                                                                        <option value="PT">PT - PERMISO TEMPORAL DE PERMANENCIA</option>
                                                                        <option value="PE">PE - PERMISO ESPECIAL DE PERMANENCIA</option>
                                                                        <option value="RC">RC - REGISTRO CIVIL</option>
                                                                        <option value="ti">TI - TARJETA DE IDENTIDAD</option>
                                                                        <option value="SC">SC - SALVOCONDUCTO DE PERMANENCIA</option>
                                                                        <option value="SI">SI - SIN IDENTIFICACION</option>
                                                                        <option value="AS">AS - ADULTO SIN IDENTIFICAR</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <CampoNit onChange={handleNit} anchoValor="65" anchoDigito="35" />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="contacto">Nombre del Contacto</label>
                                                                <input type="text" name="contacto" className="form-control" id="contacto" onChange={(e) => setContacto(e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="telefono">Teléfono</label>
                                                                <input type="text" name="telefono" className="form-control" id="telefono" onChange={(e) => setTelefono(e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="celular">Celular</label>
                                                                <input type="text" name="celular" className="form-control" id="celular" onChange={(e) => setCelular(e.target.value)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="direccion">Dirección</label>
                                                                <input type="text" name="direccion" className="form-control" id="direccion" onChange={(e) => setDireccion(e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="email">e-mail</label>
                                                                <input type="email" name="email" className="form-control" id="email" onChange={(e) => setEmail(e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="ciudad">Ciudad</label>
                                                                <SelectorCiudad 
                                                                    value={ciudad}
                                                                    onChange={handleCiudadProveedor}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="representanteLegal">Representante Legal</label>
                                                                <input type="text" name="representanteLegal" className="form-control" id="representanteLegal" onChange={(e) => setRepresentanteLegal(e.target.value)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="direccion">Banco</label>
                                                                <select name="banco" className="form-control" id="banco" onChange={(e) => setBanco(e.target.value)}>
                                                                    <option value="0">-Seleccionar Banco-</option>
                                                                    <option value="BANCAMIA S.A.">BANCAMIA S.A.</option>
                                                                    <option value="BANCO AGRARIO">BANCO AGRARIO</option>
                                                                    <option value="BANCO AV VILLAS">BANCO AV VILLAS</option>
                                                                    <option value="BANCO BBVA COLOMBIA S.A.">BANCO BBVA COLOMBIA S.A.</option>
                                                                    <option value="BANCO CAJA SOCIAL">BANCO CAJA SOCIAL</option>
                                                                    <option value="BANCO COOPERATIVO COOPCENTRAL">BANCO COOPERATIVO COOPCENTRAL</option>
                                                                    <option value="BANCO CREDIFINANCIERA">BANCO CREDIFINANCIERA</option>
                                                                    <option value="BANCO DAVIVIENDA">BANCO DAVIVIENDA</option>
                                                                    <option value="BANCO DE BOGOTA">BANCO DE BOGOTA</option>
                                                                    <option value="BANCO DE OCCIDENTE">BANCO DE OCCIDENTE</option>
                                                                    <option value="BANCO FALABELLA">BANCO FALABELLA</option>
                                                                    <option value="BANCO GNB SUDAMERIS">BANCO GNB SUDAMERIS</option>
                                                                    <option value="BANCO ITAU">BANCO ITAU</option>
                                                                    <option value="BANCO PICHINCHA S.A.">BANCO PICHINCHA S.A.</option>
                                                                    <option value="BANCO POPULAR">BANCO POPULAR</option>
                                                                    <option value="BANCO SANTANDER COLOMBIA">BANCO SANTANDER COLOMBIA</option>
                                                                    <option value="BANCO SERFINANZA">BANCO SERFINANZA</option>
                                                                    <option value="BANCOLOMBIA">BANCOLOMBIA</option>
                                                                    <option value="BANCOOMEVA S.A.">BANCOOMEVA S.A.</option>
                                                                    <option value="CFA COOPERATIVA FINANCIERA">CFA COOPERATIVA FINANCIERA</option>
                                                                    <option value="CITIBANK">CITIBANK </option>
                                                                    <option value="CONFIAR COOPERATIVA FINANCIERA">CONFIAR COOPERATIVA FINANCIERA</option>
                                                                    <option value="COTRAFA">COTRAFA</option>
                                                                    <option value="DALE">DALE</option>
                                                                    <option value="DAVIPLATA">DAVIPLATA</option>
                                                                    <option value="GIROS Y FINANZAS COMPAÑIA DE FINANCIAMIENTO S.A.">GIROS Y FINANZAS COMPAÑIA DE FINANCIAMIENTO S.A.</option>
                                                                    <option value="IRIS">IRIS</option>
                                                                    <option value="MOVII S.A.">MOVII S.A.</option>
                                                                    <option value="NEQUI">NEQUI</option>
                                                                    <option value="RAPPIPAY">RAPPIPAY</option>
                                                                    <option value="SCOTIABANK COLPATRIA">SCOTIABANK COLPATRIA</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="tipoCuenta">Tipo de Cuenta</label>
                                                                <select name="tipoCuenta" id="tipoCuenta" className="form-control" onChange={(e) => setTipoCuenta(e.target.value)}>
                                                                    <option value="ahorros">Ahorros</option>
                                                                    <option value="corriente">Corriente</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="ciudad">Número de Cuenta</label>
                                                                <input type="text" name="ciudad" className="form-control" id="ciudad" onChange={(e) => setNumeroCuenta(e.target.value)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label>Responsabilidad *</label>
                                                                <select 
                                                                    className="form-control" 
                                                                    value={codigoResponsabilidad}
                                                                    onChange={(e) => setCodigoResponsabilidad(e.target.value)}
                                                                    required
                                                                >
                                                                    <option>No Responsable</option>
                                                                    <option>Régimen Simple de Tributación</option>
                                                                    <option>Gran Contribuyente</option>
                                                                    <option>Autorretenedor</option>
                                                                    <option>Agente de Retención IVA</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label>Tipo de Régimen *</label>
                                                                <select 
                                                                    className="form-control" 
                                                                    value={codigoRegimen}
                                                                    onChange={(e) => setCodigoRegimen(e.target.value)}
                                                                    required
                                                                >
                                                                    <option>No Responsable de IVA</option>
                                                                    <option>Impuesto Sobre Las Ventas / IVA</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label>Impuesto *</label>
                                                                <select 
                                                                    className="form-control" 
                                                                    value={codigoImpuesto}
                                                                    onChange={(e) => setCodigoImpuesto(e.target.value)}
                                                                    required
                                                                >
                                                                    <option>No Causa</option>
                                                                    <option>IVA</option>
                                                                    <option>INC</option>
                                                                    <option>IVA e INC</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        

                                        <div className="row" style={{marginTop: '30px'}}>
                                            <div className="col-md-6">
                                                <Link to="/proveedores" className="btn btn-secondary" style={{marginRight: '10px'}}>
                                                    Cancelar
                                                </Link>
                                                <button type="submit" className="btn btn-primary" disabled={loading}>
                                                    Crear Proveedor&nbsp;
                                                    {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                                                    
                                                </button>
                                            </div>
                                        </div>

                                    </form>
                                </div>          
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default NuevoProveedor;